import { render, staticRenderFns } from "./TempPrelim.vue?vue&type=template&id=01309bb8&scoped=true&"
import script from "./TempPrelim.vue?vue&type=script&lang=js&"
export * from "./TempPrelim.vue?vue&type=script&lang=js&"
import style0 from "./TempPrelim.vue?vue&type=style&index=0&id=01309bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01309bb8",
  null
  
)

export default component.exports